import type {GroupListSerializer, GroupSerializer} from "@/generated/DjangoTypes";
import {i18n} from "@/i18n";
import camelCase from "lodash/camelCase";

export const groupName = (group: GroupSerializer | GroupListSerializer) =>
  group.smart || group.name === "favourite" ? i18n.t(camelCase(group.name)) : group.name;
